import React from "react";
import "../../css/Pricing.css";
import FireIcon from "../icons/FireIcon";

/**
 * Pricing component renders the pricing tiers for the restaurant's services.
 *
 * @component
 * @example
 * return (
 *   <Pricing />
 * )
 */
const Pricing = () => {
  return (
    <div className="Pricing">
      <h1>affordable solutions, big impact</h1>
      <div className="pricing-tiers">
        {/* Starter Tier */}
        <div className="tier starter">
          <h2>starter</h2>
          <p>
            perfect for small or new restaurants looking to get started with AR
            technology
          </p>
          <h3>
            $49<span>/month</span>
          </h3>
          <hr />
          <ul>
            <li>ar menu for up to 10 items</li>
            <li>basic menu management tools</li>
            <li>access to customer feedback analytics</li>
            <li>email support during business hours</li>
          </ul>
        </div>

        {/* Professional Tier */}
        <div className="tier professional">
          <h2>professional</h2>
          <div className="badge">
            <FireIcon />
            most popular
          </div>
          <p>
            great for growing restaurants ready to enhance operations and
            customer engagement
          </p>
          <h3>
            $99<span>/month</span>
          </h3>
          <hr />
          <ul>
            <li>ar menu for up to 50 items</li>
            <li>
              ai-powered waiter assistant for customer queries and menu
              recommendations
            </li>
            <li>
              advanced analytics (e.g., most-viewed items, conversion rates)
            </li>
            <li>finance automation for tips and revenue reporting</li>
            <li>priority email support</li>
          </ul>
        </div>

        {/* Enterprise Tier */}
        <div className="tier enterprise">
          <h2>enterprise</h2>
          <p>
            tailored for large restaurants and chains needing maximum
            flexibility and support
          </p>
          <h3>contact us!</h3>
          <hr />
          <ul>
            <li>unlimited AR menu items and custom menu designs</li>
            <li>advanced AI waiter assistant with multilingual support</li>
            <li>
              comprehensive analytics suite, including real-time data and
              customer insights
            </li>
            <li>custom branding options (e.g., logo integration, colors)</li>
            <li>24/7 support (email and phone)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
